import { render, staticRenderFns } from "./AddContato.vue?vue&type=template&id=641b0866&scoped=true"
import script from "./AddContato.vue?vue&type=script&lang=js"
export * from "./AddContato.vue?vue&type=script&lang=js"
import style0 from "./AddContato.vue?vue&type=style&index=0&id=641b0866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b0866",
  null
  
)

export default component.exports